import React from 'react';

import { PageHeader } from '@verantos-dev/shared-components';

import { ViewDatasetDetailModal } from './ViewDatasetDetailModal';
import { useDatasetDeliveryTableHeader } from '../hooks/useDatasetDeliveryTableHeader';

export const DatasetDeliveryTableHeader: React.FC = () => {
  const { pageTitle, isViewDatasetDetailModalOpen } = useDatasetDeliveryTableHeader();
  return (
    <>
      <PageHeader id="organizations-PageHeader" pageTitle={pageTitle} />
      {isViewDatasetDetailModalOpen && <ViewDatasetDetailModal />}
    </>
  );
};
